<article
  (touchstart)="onHoverOrTouch()"
  (mouseover)="onHoverOrTouch()"
  #buttonContainer
  class="add-remove-button-container"
>
  @if (isFromDetailPage()) {
    @if (state() === AddRemoveState.ADD) {
      <i
        (click)="addAppToFolder()"
        class="boschicon-bosch-ic-add-frame add-icon leading-none !text-[32px]"
        aria-hidden="true"
      ></i>
    } @else if (state() === AddRemoveState.REMOVE) {
      <button (click)="removeAppInstance()" class="remove">{{ 'common.remove' | translate }}</button>
    }
  } @else {
    @if (state() === AddRemoveState.ADD) {
      <button (click)="addAppToFolder()" class="add">
        <i class="boschicon-bosch-ic-add-frame"></i>
        {{ 'common.add' | translate }}
      </button>
    } @else if (state() === AddRemoveState.REMOVE) {
      <button (click)="removeAppInstance()" class="remove">{{ 'common.remove' | translate }}</button>
    }
  }
</article>

@defer (when showAddAppDialog) {
  <add-app-to-folder-dialog
    [isFromDetailPage]="isFromDetailPage()"
    [recommendedSectionIdentification]="recommendedSectionIdentification()"
    [app]="app()"
    #addAppToFolderDialog
  />
}
